
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Download, Trash2, Sparkles } from 'lucide-react';
import { Spinner } from '@/components/Spinner';

interface WeeklyMenuHeaderProps {
  onClearMenu: () => void;
  onDownloadPDF: () => void;
  onGenerateFullMenu: () => void;
  isGenerating: boolean;
}

const WeeklyMenuHeader: React.FC<WeeklyMenuHeaderProps> = ({
  onClearMenu,
  onDownloadPDF,
  onGenerateFullMenu,
  isGenerating
}) => {
  return (
    <Card className="bg-gradient-to-r from-vegana-primary/10 to-vegana-secondary/10 border-vegana-primary/20">
      <CardHeader>
        <CardTitle className="text-2xl text-vegana-primary flex items-center gap-2">
          <span className="text-2xl">📅</span>
          Menú Semanal Personalizado
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-3">
          <Button 
            onClick={onGenerateFullMenu}
            disabled={isGenerating}
            className="bg-vegana-primary hover:bg-vegana-primary/90 text-white flex items-center gap-2"
          >
            {isGenerating ? (
              <>
                <Spinner size="sm" />
                Generando...
              </>
            ) : (
              <>
                <Sparkles className="h-4 w-4" />
                Generar Menú Completo
              </>
            )}
          </Button>
          
          <Button 
            onClick={onDownloadPDF}
            variant="outline" 
            className="border-vegana-primary text-vegana-primary hover:bg-vegana-primary/10 flex items-center gap-2"
          >
            <Download className="h-4 w-4" />
            Descargar PDF
          </Button>
          
          <Button 
            onClick={onClearMenu}
            variant="outline" 
            className="border-red-400 text-red-600 hover:bg-red-50 flex items-center gap-2"
          >
            <Trash2 className="h-4 w-4" />
            Limpiar Menú
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default WeeklyMenuHeader;
